import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import priceStreamReducer from './slices/priceStreamSlice';
import currencyReducer from './slices/currencySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    priceStream: priceStreamReducer,
    currency: currencyReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;